import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'concat',
  pure: false,
})
export class ConcatPipe implements PipeTransform {
  transform(items: any[any]): any[] {
    let res = [];
    for (const item of items) {
      res = [...res, ...item];
    }
    return res;
  }
}
